import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full max-w-xl" }
const _hoisted_2 = { class: "flex justify-between items-center w-full" }
const _hoisted_3 = { class: "text-lg font-semibold text-primary-800" }
const _hoisted_4 = { class: "p-4" }
const _hoisted_5 = { class: "text-surface-500 block text-right" }
const _hoisted_6 = { class: "flex justify-between items-center mt-6" }

import { ref, computed } from "vue";
import Panel from "primevue/panel";
import Textarea from "primevue/textarea";
import Button from "primevue/button";


export default /*#__PURE__*/_defineComponent({
  __name: 'DirectTextInput',
  emits: ["generate"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const texts = ref([""]);

const panelPt = {
  root: {
    class: "shadow-md rounded-lg overflow-hidden border border-surface-200",
  },
  header: { class: "bg-surface-50 p-4 border-b border-surface-200" },
  content: { class: "bg-white" },
  toggleableContent: { class: "transition-all duration-300 ease-in-out" },
};

const textareaPt = {
  root: {
    class:
      "w-full p-3 border border-surface-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200",
  },
};

const buttonPt = {
  root: {
    class:
      "bg-primary-600 hover:bg-primary-700 text-primary-50 font-bold px-6 py-3 rounded-md transition-colors duration-200 shadow-md hover:shadow-lg",
  },
};

const addText = () => {
  if (texts.value.length < 5) {
    texts.value.push("");
  }
};

const removeText = (index: number) => {
  texts.value.splice(index, 1);
};

const isValid = computed(() => texts.value.some((text) => text.trim() !== ""));

const generatePost = () => {
  if (isValid.value) {
    emit(
      "generate",
      texts.value.filter((text) => text.trim() !== "")
    );
  }
};

const primaryButtonPt = buttonPt;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(texts.value, (text, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "mb-6"
      }, [
        _createVNode(_unref(Panel), {
          toggleable: true,
          pt: panelPt
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, "텍스트 소스 " + _toDisplayString(index + 1), 1),
              _createVNode(_unref(Button), {
                icon: "pi pi-trash",
                onClick: ($event: any) => (removeText(index)),
                severity: "danger",
                text: "",
                "aria-label": "삭제",
                pt: {
                root: {
                  class:
                    'p-2 hover:bg-red-100 rounded-full transition-colors duration-200',
                },
              }
              }, null, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(Textarea), {
                modelValue: texts.value[index],
                "onUpdate:modelValue": ($event: any) => ((texts.value[index]) = $event),
                autoResize: true,
                rows: "5",
                placeholder: "텍스트를 입력하거나 붙여넣기 하세요...",
                class: "w-full mb-2",
                pt: textareaPt
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createElementVNode("small", _hoisted_5, _toDisplayString(texts.value[index].length) + " / 3000 글자 ", 1)
            ])
          ]),
          _: 2
        }, 1024)
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_unref(Button), {
        onClick: addText,
        label: "다른 텍스트 추가",
        icon: "pi pi-plus",
        outlined: "",
        disabled: texts.value.length >= 5,
        pt: _unref(primaryButtonPt)
      }, null, 8, ["disabled", "pt"]),
      _createVNode(_unref(Button), {
        onClick: generatePost,
        label: "포스트 생성",
        icon: "pi pi-file-edit",
        disabled: !isValid.value,
        pt: _unref(primaryButtonPt)
      }, null, 8, ["disabled", "pt"])
    ])
  ]))
}
}

})